import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader2, Podcast } from 'lucide-react'

import { Layout } from '@/modules/shared/layouts/layout'
import { Button } from '@/modules/shared/components/ui/button'
import { BottomMenuComponent } from '@/modules/shared/components/bottom-menu.component'
import { Checkbox } from '@/modules/shared/components/ui/checkbox'
import { Label } from '@/modules/shared/components/ui/label'
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogTitle } from '@/modules/shared/components/ui/alert-dialog'
import { useMainStore } from '@/modules/shared/stores/main.store'

import { OrderList } from '../components/order-list/order-list.component'
import { useOrderTransmission } from '../hooks/use-order-transmission.hook'

export function OrderTransmissionPage() {
	const navigate = useNavigate()
	const { setIsLoading } = useMainStore().actions
	const [selectAll, setSelectAll] = useState(false)

	const {
		handleSelectOrRemoveOrderOfArray,
		handleSubmitOrderTransmission,
		orderSelected,
		handleSelectAll,
		handleRemoveAll,
		orders,
		isLoading
	} = useOrderTransmission()

	useEffect(() => {
		if (isLoading) {
			setIsLoading(true)
		} else {
			setIsLoading(false)
		}
	}, [isLoading])

	useEffect(() => {
		if (selectAll) {
			handleSelectAll()
		} else {
			handleRemoveAll()
		}
	}, [selectAll])

	const renderSelectAllControl = () => (
		<div className="flex items-center space-x-2 pb-2 my-3 ml-2">
			<Checkbox
				id="all"
				checked={selectAll}
				onCheckedChange={() => setSelectAll(!selectAll)}
			/>
			<Label htmlFor="all">Selecionar Todos</Label>
		</div>
	)

	const renderOrderStats = () => (
		<div className="flex items-center justify-between mt-2 mb-3 px-2">
			<p className="text-sm text-gray-600">
				{orders.length === 1
					? `${orders.length} pedido encontrado`
					: `${orders.length} pedidos encontrados`
				}
				{orderSelected.length > 0 &&
					` • ${orderSelected.length} ${orderSelected.length === 1 ? 'selecionado' : 'selecionados'}`
				}
			</p>
		</div>
	)

	const renderTransmitButton = () => (
		<Button
			disabled={!orderSelected.length || isLoading}
			aria-label="Transmitir pedidos"
			className="fixed bottom-20 lg:bottom-4 right-4 rounded-full h-14 w-14 bg-green-500 hover:bg-green-600"
			onClick={handleSubmitOrderTransmission}
		>
			<Podcast size={30} color="white" className="hover:animate-pulse" />
		</Button>
	)

	const renderLoadingDialogs = () => (
		<>


			<AlertDialog open={isLoading && orders?.length > 0}>
				<AlertDialogContent className="flex flex-col items-center flex-1 top-[95%] m-0 pb-28 md:pb-40 md:pt-10 lg:p-8 w-screen max-w-full lg:max-w-lg mb-2 lg:top-[50%] rounded-t-2xl">
					<Loader2 className="animate-spin text-primary size-10 text-center" />
					<AlertDialogTitle className="hidden">Transmitindo Pedidos</AlertDialogTitle>
					<AlertDialogDescription className="text-center mb-4">
						Transmitindo pedidos, por favor aguarde...
					</AlertDialogDescription>
				</AlertDialogContent>
			</AlertDialog>
		</>
	)

	const renderEmptyState = () => (
		<div className="flex items-center justify-center h-screen">
			<p className="text-gray-500">Nenhum pedido para transmitir</p>
		</div>
	)

	const renderContent = () => {
		if (isLoading && !orders?.length) {
			return null
		}

		if (!isLoading && orders?.length === 0) {
			return renderEmptyState()
		}

		return (
			<>
				{orders?.length > 0 && renderSelectAllControl()}
				{orders && orders.length > 0 && renderOrderStats()}
				{orders && orders.length > 0 && (
					<OrderList
						orders={orders}
						isTransmissionPage={true}
						ordersSelected={orderSelected}
						onToggleOrderSelection={handleSelectOrRemoveOrderOfArray}
					/>
				)}
				{renderTransmitButton()}
				<BottomMenuComponent />
			</>
		)
	}

	return (
		<Layout
			pageTitle="Transmissão de pedidos"
			handleGoBack={() => navigate('/')}
		>
			{renderContent()}
			{renderLoadingDialogs()}
		</Layout>
	)
}